/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './clock.component.scss.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '@angular/common';
import * as i3 from '../../../../../app/theme/pipes/capitalize.pipe';
import * as i4 from '../../../../../app/theme/components/clock/clock.component';
import * as i5 from '../../../../../app/modules/employee/service/login/login.service';
import * as i6 from '../../../../../app/modules/employee/service/account/account.service';
const styles_ClockComponent:any[] = [i0.styles];
export const RenderType_ClockComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_ClockComponent,data:{}});
export function View_ClockComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[i1.ɵpid(0,i2.DatePipe,[i1.LOCALE_ID]),i1.ɵpid(0,i3.CapitalizePipe,
      ([] as any[])),(_l()(),i1.ɵeld(2,0,(null as any),(null as any),2,'span',[['class',
      'clock-font']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted(3,(null as any),['',''])),i1.ɵppd(4,2),(_l()(),i1.ɵted(-1,(null as any),
          ['\n'])),(_l()(),i1.ɵeld(6,0,(null as any),(null as any),0,'br',([] as any[]),
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted(-1,(null as any),['\n'])),(_l()(),i1.ɵeld(8,0,(null as any),
          (null as any),3,'span',[['class','clock-font-date']],(null as any),(null as any),
          (null as any),(null as any),(null as any))),(_l()(),i1.ɵted(9,(null as any),
          ['',''])),i1.ɵppd(10,2),i1.ɵppd(11,1),(_l()(),i1.ɵted(-1,(null as any),['\n'])),
      (_l()(),i1.ɵeld(13,0,(null as any),(null as any),0,'br',([] as any[]),(null as any),
          (null as any),(null as any),(null as any),(null as any))),(_l()(),i1.ɵted(-1,
          (null as any),['\n'])),(_l()(),i1.ɵeld(15,0,(null as any),(null as any),
          1,'div',[['class','clock-username-font']],(null as any),(null as any),(null as any),
          (null as any),(null as any))),(_l()(),i1.ɵted(16,(null as any),['','']))],
      (null as any),(_ck,_v) => {
        var _co:i4.ClockComponent = _v.component;
        const currVal_0:any = i1.ɵunv(_v,3,0,_ck(_v,4,0,i1.ɵnov(_v,0),_co.clock,'shortTime'));
        _ck(_v,3,0,currVal_0);
        const currVal_1:any = i1.ɵunv(_v,9,0,_ck(_v,11,0,i1.ɵnov(_v,1),i1.ɵunv(_v,
            9,0,_ck(_v,10,0,i1.ɵnov(_v,0),_co.clock,'fullDate'))));
        _ck(_v,9,0,currVal_1);
        const currVal_2:any = _co.name;
        _ck(_v,16,0,currVal_2);
      });
}
export function View_ClockComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'app-clock',
      ([] as any[]),(null as any),(null as any),(null as any),View_ClockComponent_0,
      RenderType_ClockComponent)),i1.ɵdid(1,114688,(null as any),0,i4.ClockComponent,
      [i5.LoginService,i6.AccountService],(null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const ClockComponentNgFactory:i1.ComponentFactory<i4.ClockComponent> = i1.ɵccf('app-clock',
    i4.ClockComponent,View_ClockComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiRDovaW5ldHB1Yi93d3dyb290L2thaXplbi1uZy9zcmMvYXBwL3RoZW1lL2NvbXBvbmVudHMvY2xvY2svY2xvY2suY29tcG9uZW50Lm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL0Q6L2luZXRwdWIvd3d3cm9vdC9rYWl6ZW4tbmcvc3JjL2FwcC90aGVtZS9jb21wb25lbnRzL2Nsb2NrL2Nsb2NrLmNvbXBvbmVudC50cyIsIm5nOi8vL0Q6L2luZXRwdWIvd3d3cm9vdC9rYWl6ZW4tbmcvc3JjL2FwcC90aGVtZS9jb21wb25lbnRzL2Nsb2NrL2Nsb2NrLmNvbXBvbmVudC5odG1sIiwibmc6Ly8vRDovaW5ldHB1Yi93d3dyb290L2thaXplbi1uZy9zcmMvYXBwL3RoZW1lL2NvbXBvbmVudHMvY2xvY2svY2xvY2suY29tcG9uZW50LnRzLkNsb2NrQ29tcG9uZW50X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiPHNwYW4gY2xhc3M9XCJjbG9jay1mb250XCI+e3tjbG9jayB8IGRhdGU6J3Nob3J0VGltZSd9fTwvc3Bhbj5cclxuPGJyPlxyXG48c3BhbiBjbGFzcz1cImNsb2NrLWZvbnQtZGF0ZVwiPnt7Y2xvY2sgfCBkYXRlOidmdWxsRGF0ZScgfCBjYXBpdGFsaXplIH19PC9zcGFuPlxyXG48YnI+XHJcbjxkaXYgY2xhc3M9XCJjbG9jay11c2VybmFtZS1mb250XCI+e3tuYW1lfX08L2Rpdj4iLCI8YXBwLWNsb2NrPjwvYXBwLWNsb2NrPiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O3FCQ0FBO01BQUE7TUFBeUIsdURBQW1DO1VBQUEsU0FDNUQ7VUFBQTtNQUFJLDBDQUNKO1VBQUE7VUFBQSw0Q0FBOEI7VUFBQSxzQ0FBZ0Q7TUFDOUU7VUFBQSwwREFBSTtVQUFBLHVCQUNKO1VBQUE7VUFBQSw4QkFBaUM7OztRQUpSO1FBQUE7UUFFSztZQUFBO1FBQUE7UUFFRztRQUFBOzs7O29CQ0pqQztNQUFBOytCQUFBLFVBQUE7TUFBQTtJQUFBOzs7OyJ9



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/$$_gendir/app/theme/components/clock/clock.component.ngfactory.ts